import { createSlice } from '@reduxjs/toolkit';
import {
  getMultiCompanyAccess,
  MultiCompanyAccessApiResponse,
  selectMultiCompanyAccessCompany,
} from './MultiCompanyAccess.thunks';

export interface MultiCompanyAccessState {
  companiesResponse: MultiCompanyAccessApiResponse | null;
  isFetchingCompanies: boolean;
  isSelectingCompany: boolean;
  companiesError: string;
  selectCompanyError: string;
}

const initialState: MultiCompanyAccessState = {
  companiesResponse: null,
  isFetchingCompanies: false,
  isSelectingCompany: false,
  companiesError: '',
  selectCompanyError: '',
};

const MultiCompanyAccessSlice = createSlice({
  name: 'MultiCompanyAccess',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMultiCompanyAccess.pending, (state) => {
        state.isFetchingCompanies = true;
        state.companiesError = '';
      })
      .addCase(getMultiCompanyAccess.fulfilled, (state, { payload }) => {
        state.isFetchingCompanies = false;
        state.companiesResponse = payload;
      })
      .addCase(getMultiCompanyAccess.rejected, (state, action) => {
        state.isFetchingCompanies = false;
        state.companiesError = action.payload
          ? JSON.stringify(action.payload)
          : 'unknown_error';
      })
      .addCase(selectMultiCompanyAccessCompany.pending, (state) => {
        state.isSelectingCompany = true;
        state.selectCompanyError = '';
      })
      .addCase(selectMultiCompanyAccessCompany.fulfilled, (state, action) => {
        state.isSelectingCompany = false;
        if (state.companiesResponse) {
          state.companiesResponse.data.current_company_id =
            action.meta.arg.companyId;
        }
      })
      .addCase(selectMultiCompanyAccessCompany.rejected, (state, action) => {
        state.isSelectingCompany = false;
        state.selectCompanyError = action.payload ?? 'unknown_error';
      });
  },
});

export default MultiCompanyAccessSlice.reducer;
